import { http } from "./http";

function buildNotificationBody(payload = {}, mediaFile = null) {
  if (!mediaFile) return payload;

  const form = new FormData();

  for (const [key, value] of Object.entries(payload || {})) {
    if (value === undefined || value === null || value === "") continue;
    form.append(key, String(value));
  }

  form.append("media", mediaFile);
  return form;
}

export const UserNotificationsService = {
  async listPushUsers(params = {}) {
    return http("/api/admin/user-notifications/users", {
      method: "GET",
      params: {
        page: 1,
        limit: 20,
        ...params,
      },
    });
  },

  async listStates() {
    return http("/api/admin/user-notifications/states", {
      method: "GET",
    });
  },

  async sendNotification(payload, mediaFile = null) {
    return http("/api/admin/user-notifications/send", {
      method: "POST",
      body: buildNotificationBody(payload, mediaFile),
    });
  },

  async listScheduled(params = {}) {
    return http("/api/admin/user-notifications/scheduled", {
      method: "GET",
      params: {
        limit: 50,
        ...params,
      },
    });
  },

  async scheduleNotification(payload, mediaFile = null) {
    return http("/api/admin/user-notifications/schedule", {
      method: "POST",
      body: buildNotificationBody(payload, mediaFile),
    });
  },

  async cancelScheduled(id) {
    return http(`/api/admin/user-notifications/scheduled/${id}/cancel`, {
      method: "PATCH",
    });
  },

  async clearScheduledHistory() {
    return http("/api/admin/user-notifications/scheduled/history", {
      method: "DELETE",
    });
  },
};
